// Put your application javascript here
(function () {
	document.addEventListener("DOMContentLoaded", function () {
		var countdownTimers = document.querySelectorAll(".countdown-timer");
		if (countdownTimers.length) {
			function initCountdown(el, countDownDate) {
				var x = setInterval(function () {
					// Get today's date and time
					var now = new Date().getTime();
					// Find the distance between now and the count down date
					var distance = countDownDate - now;

					// Time calculations for days, hours, minutes and seconds
					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor(
						(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
					);
					var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);

					// Display the result in the element with id="demo"
					el.innerHTML =
						days + "D:" + hours + "H:" + minutes + "M:" + seconds + "S";
					// If the count down is finished, write some text
					if (distance < 0) {
						clearInterval(x);
						// 						document.getElementById("demo").innerHTML = "EXPIRED";
					}
				}, 1000);
			}
			for (var i = 0; i < countdownTimers.length; i++) {
				var timerEl = countdownTimers[i];
				var date = new Date(timerEl.getAttribute("datetime")).getTime();
				initCountdown(timerEl, date);
			}
		}
	});

	document.addEventListener("DOMContentLoaded", function () {
		$(".marquee").marquee({
			//duration in milliseconds of the marquee
			speed: 80,
			gap: 0,
			delayBeforeStart: 0,
			direction: "left",
			duplicated: true,
			startVisible: true,
		});

		$(".main-carousel").flickity({
			cellAlign: "center",
			contain: true,
			wrapAround: true,
			autoPlay: 3000,
			pageDots: false,
			// pauseAutoPlayOnHover: false,
		});

		const $carousel = $(".collection-carousel").flickity({
			cellAlign: "center",
			contain: true,
			pageDots: false,
			gap: 20,
			freeScroll: window.innerWidth > 768,
			// pauseAutoPlayOnHover: false,
		});

		const nextBtns = document.querySelectorAll(".next-btn");
		const prevBtns = document.querySelectorAll(".prev-btn");
		if (nextBtns && nextBtns.length > 0) {
			nextBtns.forEach((b) => {
				b.addEventListener("click", () => {
					$carousel.flickity("next", true);
				});
			});
		}
		if (prevBtns && prevBtns.length > 0) {
			prevBtns.forEach((b) => {
				b.addEventListener("click", () => {
					$carousel.flickity("previous", true);
				});
			});
		}
	});
})();

